/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSortAscending = createReactComponent("sort-ascending", "IconSortAscending", [
  ["path", { d: "M4 6l7 0", key: "svg-0" }],
  ["path", { d: "M4 12l7 0", key: "svg-1" }],
  ["path", { d: "M4 18l9 0", key: "svg-2" }],
  ["path", { d: "M15 9l3 -3l3 3", key: "svg-3" }],
  ["path", { d: "M18 6l0 12", key: "svg-4" }]
]);

export { IconSortAscending as default };
//# sourceMappingURL=IconSortAscending.js.map
